import React from 'react';
import clsx from 'clsx';

const MultilineText = ({ className, ...props }) => {
  return <div className={clsx('whitespace-pre-line wrap-anywhere', className)} {...props} />;
};

export default MultilineText;
